export const environment = {
    production: true,
    VERSION : "32805"
};